import { jsx as _jsx } from "react/jsx-runtime";
export default function CheckIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /*#__PURE__*/_jsx("polyline", {
      points: "20 6 9 17 4 12"
    })
  });
}